import { Card } from "@radix-ui/themes";
import PropTypes from "prop-types";

BottomRightMapDiv.propTypes = {
  children: PropTypes.node,
};

export default function BottomRightMapDiv({ children }) {
  return (
    <Card
      id="bottom-right-map-div"
      style={{
        position: "absolute",
        bottom: 45,
        right: 10,
        zIndex: 1000,
        backgroundColor: "white",
        borderRadius: "var(--radius-4)",
      }}
    >
      {children}
    </Card>
  );
}
